import { AppBar, Avatar, Grid2, Menu, MenuItem, Toolbar } from '@mui/material';
import './navbar.css';
import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import Logo from '../../assets/images/logo.png';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import notifications from '../../assets/icons/notifications.svg';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import altAvatar from '../../assets/images/altAvatar.svg';

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '20ch',
      },
    },
}));

const Navbar = () => {

    const Navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const logoutPanelUser = () => {
        var token = localStorage.getItem('token');
        localStorage.removeItem('token');
        Navigate('/signup');
    }

    return(
        // <Box>
            <AppBar position="static" className="appbarr">
                <Toolbar>

                <img src={Logo} alt="Company Logo" height="14%" width="14%" />

                <Search>
                    <SearchIconWrapper>
                    <SearchIcon />
                    </SearchIconWrapper>
                    <StyledInputBase
                    placeholder="Search…"
                    inputProps={{ 'aria-label': 'search' }}
                    />
                </Search>

                <Grid2 container spacing={2} alignItems="center" sx={{ ml: 'auto', width: 'auto' }}>

                    <Grid2 item>
                        <select style={{padding:'12px 24px', border: '1px solid #E6F0FF', borderRadius:'10px'}}>
                            <option value="">Language</option>
                        </select>
                    </Grid2>

                    <Grid2 item>
                        <select style={{padding:'12px 24px', border: '1px solid #E6F0FF', borderRadius:'10px'}}>
                            <option value="">Country</option>
                        </select>
                    </Grid2>

                    <Grid2 item style={{border: '1px solid #E6F0FF', borderRadius: '8px', padding: '10px', color:'#1A1E25' }}>
                        {/* <NotificationsNoneIcon/> */}
                        <img src={notifications} width="16px" height="16px" alt="notifiaction"/>
                    </Grid2>

                    <Grid2 item sx={{border: '1px solid #E6F0FF', borderRadius:'18px'}}>
                        <Avatar alt="profile" src={altAvatar} aria-controls={open ? 'demo-positioned-menu' : undefined}
                         aria-haspopup="true" aria-expanded={open ? 'true' : undefined} onClick={handleClick}/>


                        <Menu id="demo-positioned-menu" aria-labelledby="demo-positioned-button"
                         anchorEl={anchorEl} open={open} onClose={handleClose} anchorOrigin={{vertical:'top', horizontal:'left'}}
                            transformOrigin={{ vertical: 'top', horizontal: 'left'}}>
                            {/* <MenuItem onClick={handleClose}>Profile</MenuItem>
                            <MenuItem onClick={handleClose}>My account</MenuItem> */}
                            <MenuItem onClick={logoutPanelUser}>Logout</MenuItem>
                        </Menu>
                    </Grid2>
                    
                </Grid2>
                </Toolbar>
            </AppBar>
        // </Box>
    )
};

export default Navbar;